import { REQUEST_TYPE } from '@/constants/request-type'

export function getRequestIconById(id?: string) {
  if (!id) return undefined

  const iterable = Object.values(REQUEST_TYPE)
  const found = iterable.find((item) => item.id === id)

  return found?.icon
}
